import { ButtonGroup, Button, DialogBody, DialogFooter, Text, Stack } from "@chakra-ui/react";
import { UI } from "components";
import { toaster } from "config";
import { API } from "config";
import useOrder from "hooks/useOrder";
import { useState } from "react";

export default function Done({ data, ...props}){

    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)

    const handleDone = async () => {
        setLoading(true)

        try{
            await API.put(`/orders/${order?.data?.id}/done`)
            toaster.create({ title: 'O pedido foi concluído', type: 'success' })
            order.refetch()
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível concluir o pedido', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog size="sm" loading={loading} title={`Concluir pedido #${order.data?.cod}?`} {...props}>
        <DialogBody>
            <Stack gap={4}>
                <Text>Ao marcar o pedido como recebido, você assume a responsabilidade de que o pedido realmente já esteja em mãos e que os produtos já podem ser adicionados ao seu estoque.</Text>
                <Text>Tem certeza que deseja continuar?</Text>
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup size="xs">
                <Button colorPalette="green" loading={loading} loadingText="Confirmando recebimento..." onClick={handleDone}><UI.Icon name="done" /> Marcar como recebido</Button>
                <Button variant="ghost" onClick={props.onClose} disabled={loading}>Fechar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )
}